import { makeStyles, withStyles } from '@material-ui/styles'
import { amber } from '@material-ui/core/colors'
import { TableCell, TableRow } from '@material-ui/core'

const styles = (theme => ({
        root: {
            width: '100%',
            marginTop: theme.spacing(0),
            padding: theme.spacing(1),
            overflowX: 'auto',
        },
        filterContainer: {
            display: 'flex',
            justifyContent: 'left',
            marginBottom: theme.spacing(2),
            marginTop: theme.spacing(2),
        },
        table: {
            minWidth: 700,
        },
        button: {
            margin: theme.spacing(1),
        },
        selectedFilterType: {
            backgroundColor: '#199E74',
            border: '1px solid #199E74',
            fontSize: '9px !important',
            color: 'white',
            "&:hover": {
                backgroundColor: '#199E74',
            },
        },
        notificationSpan: {
            float: 'right',
            color: 'red',
            paddingTop: '10px'
        },
        defaultFilterType: {
            fontSize: '9px !important',
            border: '1px solid #199E74',
            color: '#199E74',
        },
        filterButtonGroupHolder: {
            marginLeft: '5px',
            marginTop: '5px'
        },
        filterButton: {
            marginLeft: '5px',
            border:'0px',
            borderBottom: '0.5px solid black',
            backgroundColor: 'transparent',
            padding: '1px 5px',
            "&:hover":{
                backgroundColor: '#e9e9e9',
                borderRadius: '3px',
                cursor: 'pointer'
            }
        },
        warningButton: {
            backgroundColor: amber[700],
        },
        hidden: {
            display: 'none',
        },
        form: {
            display: 'flex',
            flexDirection: 'column',
            margin: 'auto',
            width: 'fit-content',
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 200,
        },
        selectEmpty: {
            marginTop: theme.spacing(2),
        },
        boldtext: {
            fontWeight: 'bold',
        },
        typo: {
            color: theme.palette.text.hint,
            marginTop: theme.spacing(1),
        },
        bgBlack: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
            border: 'solid 1px lightgrey',
        },
        bgBlueGrey: {
            backgroundColor: '#424242',
            color: theme.palette.common.white,
            border: 'solid 1px lightgrey',
        },
        bgGrey: {
            backgroundColor: '#616161',
            color: theme.palette.common.white,
        },
        bgLightGrey: {
            backgroundColor: '#757575',
            color: theme.palette.common.white,
        },
        bgWhite: {
            border: '1px solid #ffffff',
        },
        bgLightBlue: {
            backgroundColor: '#dbe5f1',
            color: theme.palette.common.black,
            border: '1px solid white',
        },
        bgSummary: {
            backgroundColor: '#d9d6e4',
            color: theme.palette.common.black,
        },
        bgLightGreen: {
            backgroundColor: '#6fcdb3',
            color: theme.palette.common.black,
            border: '1px solid white',
        },
        noBorder: {
            border: '0px !important',
        },
        emptyRow: {
            height: '40px !important',
        },
        dataFieldformControl: {
            width: 310,
            margin: 8,
        },
        buttonFormControl: {
            width: 100,
            margin: 8,
            display: 'contents'
        },
        fieldListItem: {
            paddingTop: 0,
            paddingBottom: 0,
        },
        fieldFilterTitle: {
            marginTop: 8,
        },
        noTopMargin: {
            marginTop: 0,
        },
        downloadBtnSection: {
            textAlign: 'right',
        },
        reportTableContainer: {
            overflowX: 'scroll',
            paddingBottom: '15px'
        },
        reportTable: {
            overflow: 'scroll',
        },
        leftJustified: {
            textAlign: 'left',
		},
		subFilter: {

		},
		mainFilterContainer: {
			marginLeft: '7px',
			marginRight: '20px',
		},
		mainFilter: {
			width: '325px',
			marginLeft: '7px',
		},
		filterText: {
			color: '#4A4A4A',
			fontSize: '11px',
		},
		labelText: {
			color: '#4A4A4A',
        },
        formMinWidth: {
            minWidth: 70,
        },
        
    })
)

const StyledTableCell = withStyles(theme => ({
    head: {
        padding: theme.spacing(1),
        fontSize: 12,
        border: 'solid 1px lightgrey',
        textAlign: 'center',
    },
    body: {
        fontSize: 11,
        textAlign: 'center',
        whiteSpace: 'nowrap',
    },
}))(TableCell)

const StyledTableRow = withStyles(theme => ({
    root: {
        height: 'auto',
    },
}))(TableRow)

const useStyles = makeStyles(styles)
export {
    styles,
    useStyles,
    StyledTableRow,
    StyledTableCell,
}

export default useStyles
